import React from 'react';
import   TwoLines  from './assests/TwoLines.svg';
import TwoDots from './assests/TwoDots.svg';

type CategoryCardProps = {
  image: string;
  headText: string;
  subText: React.ReactNode;
  categoryId: number;
  onCategoryClick: (categoryId: number) => void;
};

const CategoryCard: React.FC<CategoryCardProps> = ({ 
  image, 
  headText, 
  subText, 
  categoryId, 
  onCategoryClick 
}) => {
  const handleCardClick = () => {
    onCategoryClick(categoryId);
  };

  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent card click when button is clicked
    onCategoryClick(categoryId);
  };

  return (
    <div 
      className="relative md:w-[365px] md:h-[240px] w-[320px] h-[220px] rounded-lg overflow-hidden cursor-pointer group"
      onClick={handleCardClick}
      style={{borderRadius: '16px'}}
    >
      {/* Background image overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-60 transition-all duration-300"></div>
      
      {/* Background image - replace with actual image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${image})`
        }}
      ></div>
      
      
      
      {/* Content */}
      <div className="absolute bottom-6 mb-[-80px] ml-[20px] left-6 z-10 group-hover:mb-[-20px]">
        {/* Title - moves up on hover */}
        
        <h3 className="text-left text-white text-3xl font-medium group-hover:-translate-y-16 transition-all duration-300"
          style={{fontFamily: 'Manrope, sans-serif',borderRadius: '16px'}}
        >
          <span><img src={TwoLines} className='mb-[5px] mr-3' alt="Two Lines Icon" /> </span>
          {headText}
        </h3>
        
        {/* Hover content - appears below the moved title */}
        <div className="text-left font-inter pr-[30px] font-normal text-base leading-[1.3] tracking-normal opacity-0 group-hover:opacity-100 group-hover:-translate-y-12 transition-all duration-300"
          style={{fontFamily: 'Inter, sans-serif'}}
        >
          <p className="text-white text-md mb-4 leading-relaxed">
            {subText}
          </p>
          
          {/* CTA Button */}
          <button 
            style={{fontFamily: 'Inter, sans-serif'}}
            onClick={handleButtonClick}
          >
            SEE AI AGENTS <img src={TwoDots} alt="Two Dots" className="inline-block ml-2" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;